<template>
  <div id="map-container" v-show="ready">
    <GMapMap ref="GMapRef" :center="center" :zoom="zoom"
      map-type-id="terrain">
      <GMapCluster>
        <GMapMarker :key="index" v-for="(module, index) in module_list"
          :position="{ lat: module.model.latitude, lng: module.model.longitude }" :clickable="true"
          :title="module.model.name" @click="onMarkerClicked(module)">
          <GMapInfoWindow :opened="openedMarkerID === module.model.name">
            <div v-if="no_data_for_this_module">
              {{$t($route.name+'.noDataForModule')}}
            </div>
            <ModInfoOverlayBox v-else :module_name="name" :temperature="temp" :rel_humidity="hr" :rainmeter="rain"
              :key="selected_module" />
          </GMapInfoWindow>
        </GMapMarker>
      </GMapCluster>
    </GMapMap>
  </div>
</template>

<script>
import ModInfoOverlayBox from "./ModInfoOverlayBox"


const DEFAULT_ZOOM = 12;

const selectorUI = document.createElement('select');
selectorUI.className = "selector-container"

export default {
  name: "GoogleMap",
  components: {
    ModInfoOverlayBox
  },
  props:
  {
    module_list: Array,
  },
  mounted() {
    // console.log("Getting here")
    this.getUserLocation();
    this.loadMap();
    this.ready = true;
  },
  methods: {
    loadMap() {
      this.$refs.GMapRef.$mapPromise.then((map) => {

        map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(
          this.getModuleSelector()
        );
      });
    },
    getModuleSelector() {

      const selectorContainer = document.createElement('div')
      selectorContainer.className = 'selector-container'

      this.module_list.forEach((module, index) => {
        const optionUI = document.createElement('option')
        optionUI.text = module.model.name
        optionUI.name = index
        optionUI.selected = index == this.selected
        optionUI.className = "option-class"
        selectorUI.appendChild(optionUI)
      });
      selectorUI.addEventListener('change', this.onChange)
      selectorContainer.appendChild(selectorUI)
      return selectorUI;

    },
    updateModuleSelected() {
      const options = Array.from(selectorUI.options)

      const optionToModify = options.find(item => item.name === this.selected)
      if (optionToModify != null) {
        selectorUI.value = optionToModify.value
      }

    },
    getUserLocation() {

      if ("geolocation" in navigator) {
        // check if geolocation is supported by the browser
        navigator.geolocation.getCurrentPosition((position) => {
          // get the current position
          this.center.lat = position.coords.latitude
          this.center.lng = position.coords.longitude
        });
      } else {
        // console.log("Geolocation is not supported by this browser.");
      }
    },
    onMarkerClicked(module) {
      this.center.lat = module.model.latitude
      this.center.lng = module.model.longitude
      this.selected = this.module_list.indexOf(module)
      this.openMarker(module.model.name)
      this.moduleDataFill(module)
      this.updateModuleSelected();
    },
    onChange() {

      const options = Array.from(selectorUI.options)

      const selectedOption = options.find(item => item.text === selectorUI.value)
      if (selectedOption == null) {
        // console.log("not found")
        return
      }
      this.selected = selectedOption.name
      // console.log(this.module_list[this.selected])
      this.onMarkerClicked(this.module_list[this.selected])
    },
    openMarker(name) {
      this.openedMarkerID = name
    },
    moduleDataFill(module) {
      const date = new Date();
      const date_formated = date.toISOString().split('T')[0]
      const measure_date = module.daily_data.processed.data_measured_datetime.split('T')[0]
      this.name = module.model.name;
      if (date_formated !== measure_date) {
        this.no_data_for_this_module = true;
        return;
      }
      this.no_data_for_this_module = false;
      module.daily_data.processed.sensors_data.forEach(sensor => {
        switch (sensor.measure) {
          case 'temp_meter':
            this.temp = sensor.value
            break;
          case 'rain_meter':
            this.rain = sensor.value
            break;
          case 'hum_meter':
            this.hr = sensor.value
            break;
          default:
            break;
        }
      });
    }
  },
  data() {
    return {
      selected: null,
      center: { lat: 0.0, lng: 0.0 },
      ready: false,
      zoom: DEFAULT_ZOOM,
      openedMarkerID: null,
      name: "",
      temp: 0,
      hr: 0,
      rain: 0,
      no_data_for_this_module: false,
    }
  }
};

</script>

<style>
#map-container {
  height: 75vh;
  top: 1;
}

.selector-container {
  margin: 10px;
  height: 40px;
  font-size: 18px;

}

.option-class {
  text-size-adjust: 15px;
}
</style>